const config = {
    "currentAcademicYearId": "6846a42d545ed2bf5ae0ca99",
    "baseName": '/wested',
    basePath: '',
    // "basePath": 'http://localhost:9415/wested/',
    "SUB_END_DATE": "2028-07-31T00:00:00.000+00:00",
    "LAST_YEAR_END_DATE" : "2025-07-31T00:00:00.000+00:00"
}

export default config;